import { bootstrap } from './router';
import './styles.css';

const root = document.getElementById('app');
if (root) {
  try {
    // Routing: `/` Dashboard bzw. Entwurfs-Editor, `/join` anonymer Editor, `/p/:id` Projekt-Editor
    bootstrap(root);
  } catch (err) {
    // Ein Bootstrap-Fehler darf nie eine leere Seite hinterlassen
    console.error('CampSketch-Start fehlgeschlagen:', err);
    root.replaceChildren();
    root.className = 'auth-screen';
    const card = document.createElement('div');
    card.className = 'auth-card';
    const h1 = document.createElement('h1');
    h1.textContent = 'CampSketch konnte nicht starten';
    const p = document.createElement('p');
    p.className = 'auth-hint';
    p.textContent = err instanceof Error ? err.message : String(err);
    const retry = document.createElement('button');
    retry.className = 'auth-submit';
    retry.textContent = 'Neu laden';
    retry.onclick = () => location.reload();
    card.append(h1, p, retry);
    root.appendChild(card);
  }
}
